/* tslint:disable */

declare var Object: any;
export interface SFClaimRequestInterface {
  "id"?: number;
}

export class SFClaimRequest implements SFClaimRequestInterface {
  "id": number;
  constructor(data?: SFClaimRequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFClaimRequest`.
   */
  public static getModelName() {
    return "SFClaimRequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFClaimRequest for dynamic purposes.
  **/
  public static factory(data: SFClaimRequestInterface): SFClaimRequest{
    return new SFClaimRequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFClaimRequest',
      plural: 'SFClaimRequests',
      path: 'SFClaimRequests',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFClaimRequest.ts